"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

// eslint-disable-next-line complexity
var Item = function Item(_ref) {
  var _cx;

  var id = _ref.id,
      activeItemId = _ref.activeItemId,
      indentLevel = _ref.indentLevel,
      name = _ref.name,
      className = _ref.className,
      options = _ref.options,
      _onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "activeItemId", "indentLevel", "name", "className", "options", "onClick"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme,
    props: {
      indentLevel: indentLevel
    }
  });

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])(classes.Item, className)
  }, /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('button', (_cx = {}, (0, _defineProperty2["default"])(_cx, 'active', activeItemId === id), (0, _defineProperty2["default"])(_cx, 'expanded', expanded), _cx))
  }), (options === null || options === void 0 ? void 0 : options.length) ? /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(classes.Arrow, {
      'down': expanded
    })
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.Spacer
  }), /*#__PURE__*/React.createElement(_Link["default"], {
    id: id,
    "data-test-id": id,
    type: "button",
    onClick: function onClick() {
      _onClick(id);

      if ((options === null || options === void 0 ? void 0 : options.length // if there are children
      ) && !(activeItemId !== id && expanded)) // and it's not an inactive and expanded item 
        setExpanded(!expanded);
    },
    title: name
  }, name), activeItemId === id && /*#__PURE__*/React.createElement(_Icon["default"], {
    glyph: "chevron-right"
  })), (options === null || options === void 0 ? void 0 : options.length) && expanded ? options === null || options === void 0 ? void 0 : options.map(function (opt, ind) {
    return /*#__PURE__*/React.createElement(Item, (0, _extends2["default"])({
      key: opt.id
    }, opt, {
      activeItemId: activeItemId,
      indentLevel: indentLevel + 1,
      onClick: _onClick,
      className: ind % 2 > 0 ? 'even' : undefined
    }));
  }) : null);
};

/**
 * SidebarMenu component to select value from options.
 */
var SidebarMenu = function SidebarMenu(_ref2) {
  var id = _ref2.id,
      activeItemId = _ref2.activeItemId,
      options = _ref2.options,
      onClick = _ref2.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["id", "activeItemId", "options", "onClick"]);
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    id: id,
    "data-test-id": id
  }), options === null || options === void 0 ? void 0 : options.map(function (opt, ind) {
    return /*#__PURE__*/React.createElement(Item, (0, _extends2["default"])({
      key: opt.id
    }, opt, {
      activeItemId: activeItemId,
      indentLevel: 0,
      onClick: onClick,
      className: ind % 2 > 0 ? 'even' : undefined
    }));
  }));
};

exports["default"] = SidebarMenu;
SidebarMenu.Item = Item;
//# sourceMappingURL=index.js.map